import { BillingOverviewRecordType } from '@bn/shared/entities/enums';
import { BillingOverviewRecordTypeConfigModel } from './models/billing-history-type-config.model';

export const billingOverviewRecordTypeConfig: BillingOverviewRecordTypeConfigModel = {
  [BillingOverviewRecordType.PayPal]: {
    title: `Paypal payment %s%`,
    contextType: 'success',
    badgeText: 'PayPal',
  },
  [BillingOverviewRecordType.Bitcoin]: {
    title: `Crypto payment %s%`,
    contextType: 'success',
    badgeText: 'Crypto',
  },
  [BillingOverviewRecordType.CreditCard]: {
    title: `Credit card payment %s%`,
    contextType: 'success',
    badgeText: 'Credit card',
  },
  [BillingOverviewRecordType.MonthlyUsage]: {
    title: `Monthly usage for %s%`,
    contextType: 'danger',
    badgeText: 'Monthly usage',
  },
  [BillingOverviewRecordType.Refund]: {
    title: `Refund %s%`,
    contextType: 'success',
    badgeText: 'Refund',
  },
  [BillingOverviewRecordType.CouponCode]: {
    title: `Coupon code %s%`,
    contextType: 'warning',
    badgeText: 'Coupon code',
  },
  [BillingOverviewRecordType.BankTransfer]: {
    title: `Bank transfer %s%`,
    contextType: 'success',
    badgeText: 'Bank transfer',
  },
  [BillingOverviewRecordType.AffiliateCredits]: {
    title: `Affiliate credits transfer`,
    contextType: 'warning',
    badgeText: 'Affiliate Credits',
  },
};
